import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const TermsConditions = () => {
  return (
    <div className="bg-gray-900 pt-14 min-h-screen text-white">
      <Navbar />
      <div className="container mx-auto px-4 py-12">
        <h1 className="text-4xl md:text-5xl font-extrabold mb-8 text-center">
          Conditions Générales
        </h1>

        <p className="mb-6">
          Les présentes Conditions Générales régissent l'utilisation du site web
          <strong> WebMinds</strong>. En accédant ou en utilisant ce site, vous
          acceptez d'être lié par ces conditions. Veuillez les lire
          attentivement.
        </p>

        <h2 className="text-3xl font-bold mb-6 border-b-4 border-blue-400 pb-2">
          Acceptation des Conditions
        </h2>
        <p className="mb-6">
          En accédant à ce site, vous acceptez d'être lié par ces conditions
          générales ainsi que par toutes les lois et règlements applicables. Si
          vous n'acceptez pas ces conditions, veuillez ne pas utiliser ce site.
        </p>

        <h2 className="text-3xl font-bold mb-6 border-b-4 border-green-400 pb-2">
          Modifications des Conditions
        </h2>
        <p className="mb-6">
          Nous nous réservons le droit de modifier ces Conditions Générales à
          tout moment. Les modifications seront publiées sur cette page et
          seront applicables dès leur publication. Il est de votre
          responsabilité de consulter régulièrement cette page pour prendre
          connaissance des modifications éventuelles.
        </p>

        <h2 className="text-3xl font-bold mb-6 border-b-4 border-yellow-400 pb-2">
          Utilisation du Site
        </h2>
        <p className="mb-6">
          Vous vous engagez à utiliser le site <strong>WebMinds</strong>{" "}
          uniquement à des fins légales et conformément à ces conditions. Vous
          acceptez de ne pas utiliser le site d'une manière qui pourrait
          endommager, désactiver, surcharger ou détériorer le site, ou
          interférer avec l'utilisation de celui-ci par d'autres parties.
        </p>

        {/* <h2 className="text-3xl font-bold mb-6 border-b-4 border-red-400 pb-2">
          Propriété Intellectuelle
        </h2>
        <p className="mb-6">
          Le contenu du site <strong>WebMinds</strong>, y compris les textes,
          images, graphiques, logos, et autres éléments, est protégé par les
          droits de propriété intellectuelle. Toute reproduction, distribution,
          ou modification de ces éléments sans autorisation préalable est
          interdite.
        </p> */}

        <h2 className="text-3xl font-bold mb-6 border-b-4 border-purple-400 pb-2">
          Responsabilité
        </h2>
        <p className="mb-6">
          <strong>WebMinds</strong> ne saurait être tenu responsable des
          dommages directs ou indirects résultant de l'utilisation ou de
          l'impossibilité d'utiliser le site. Nous ne garantissons pas que le
          site sera exempt d'erreurs ou d'interruptions.
        </p>

        <h2 className="text-3xl font-bold mb-6 border-b-4 border-blue-400 pb-2">
          Liens Externes
        </h2>
        <p className="mb-6">
          Le site peut contenir des liens vers des sites externes. Ces liens
          sont fournis à titre de commodité. <strong>WebMinds</strong> n'a aucun
          contrôle sur ces sites et n'assume aucune responsabilité quant à leur
          contenu ou leur disponibilité.
        </p>

        {/* <h2 className="text-3xl font-bold mb-6 border-b-4 border-green-400 pb-2">
          Données Personnelles
        </h2>
        <p className="mb-6">
          La collecte et l'utilisation des données personnelles sont régies par
          notre Politique de Confidentialité. En utilisant le site, vous
          acceptez notre Politique de Confidentialité.
        </p> */}

        <h2 className="text-3xl font-bold mb-6 border-b-4 border-green-400 pb-2">
          Droit Applicable
        </h2>
        <p className="mb-6">
          Les présentes Conditions Générales sont régies par le droit français.
          En cas de litige, les tribunaux français seront seuls compétents.
        </p>

        <p className="mb-6">Dernière mise à jour : 16 août 2024</p>
      </div>
      <Footer />
    </div>
  );
};

export default TermsConditions;
